import { get, patch, post } from '@/shared/api/api-client';
import { injectable } from 'inversify';
import {
  ConsentItem,
  DerivedLot,
  DlpElevator,
  DlpLot,
  GrainSegment,
  LabSegment,
  MixStep,
} from '../ts';

@injectable()
export class DlpService {
  getElevators(): Promise<DlpElevator[]> {
    return get(`${PUBLIC_API_URL}/elevator`, {}, document.cookie);
  }

  getLots(): Promise<DlpLot[]> {
    return get(`${PUBLIC_API_URL}/digital-lots`, {}, document.cookie);
  }

  getLot(id: number): Promise<DlpLot> {
    return get(`${PUBLIC_API_URL}/digital-lots/${id}`, {}, document.cookie);
  }

  createDraft(dto: { offer_id: number; elevator_id: number; target_weight: number }): Promise<DlpLot> {
    return post(`${PUBLIC_API_URL}/digital-lots`, { ...dto }, document.cookie);
  }

  submit(id: number) {
    return post(`${PUBLIC_API_URL}/digital-lots/${id}/submit`, {}, document.cookie);
  }

  reserve(id: number) {
    return post(`${PUBLIC_API_URL}/digital-lots/${id}/reserve`, {}, document.cookie);
  }

  form(id: number) {
    return post(`${PUBLIC_API_URL}/digital-lots/${id}/form`, {}, document.cookie);
  }

  cancel(id: number) {
    return post(`${PUBLIC_API_URL}/digital-lots/${id}/cancel`, {}, document.cookie);
  }

  getDerived(): Promise<DerivedLot[]> {
    return get(`${PUBLIC_API_URL}/derived-lots`, {}, document.cookie);
  }

  finalize(id: number, dto: { carrier_type?: string; carrier_number?: string }) {
    return post(`${PUBLIC_API_URL}/derived-lots/${id}/finalize`, { ...dto }, document.cookie);
  }

  certify(id: number, dto: { cert_number: string; cert_date: string; cert_lab?: string }) {
    return post(`${PUBLIC_API_URL}/derived-lots/${id}/certify`, { ...dto }, document.cookie);
  }

  ship(id: number) {
    return post(`${PUBLIC_API_URL}/derived-lots/${id}/ship`, {}, document.cookie);
  }

  // --- Владелец зерна ---
  getMySegments(): Promise<GrainSegment[]> {
    return get(`${PUBLIC_API_URL}/grain/segments`, {}, document.cookie);
  }

  getConsents(): Promise<ConsentItem[]> {
    return get(`${PUBLIC_API_URL}/grain/consents`, {}, document.cookie);
  }

  consent(itemId: number, decision: 'approved' | 'rejected') {
    return post(`${PUBLIC_API_URL}/grain/consents/${itemId}`, { decision }, document.cookie);
  }

  // --- Лаборант ---
  getLabSegments(): Promise<LabSegment[]> {
    return get(`${PUBLIC_API_URL}/lab/segments`, {}, document.cookie);
  }

  updateSegmentQuality(id: number, values: Record<string, number>) {
    return patch(`${PUBLIC_API_URL}/lab/segments/${id}/quality`, { values });
  }

  getMixSteps(): Promise<MixStep[]> {
    return get(`${PUBLIC_API_URL}/lab/mix-steps`, {}, document.cookie);
  }

  updateMixStep(id: number, fact_quality: Record<string, number>) {
    return patch(`${PUBLIC_API_URL}/lab/mix-steps/${id}`, { fact_quality });
  }
}
